import { useEffect } from "react"
import { useApiData } from "./useApiData"
import IUser from "models/IUser"

const useIdentifySegmentUser = () => {
  const { data: user } = useApiData<IUser>(`accounts/user/`)

  useEffect(() => {
    if (!user?.id) return
    window?.analytics?.identify?.(user.id)
  }, [user])
}

export default useIdentifySegmentUser
